// Remembers the listing a reader clicked a post from — its display label
// ("All", "Insurance", ...) and its exact URL — so the post's "Return to X"
// link sends them back to precisely that listing instead of always
// resetting to the post's own category at page 1. "All" is treated as a
// real category here, same as any named one.
//
// The URL is stored verbatim (not reconstructed from a category+page pair)
// so it always matches exactly what the listing page itself navigated to —
// trailing slash, ?Year= filters and all — instead of drifting out of sync
// with it.
const STORAGE_KEY = 'blogReturnContext';

export function storeReturnContext(subsection, routedFromURL) {
  if (!subsection || !routedFromURL) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ subsection, routedFromURL })
    );
  } catch (err) {
    // sessionStorage unavailable (privacy mode, etc.) — safe to ignore,
    // the return link just falls back to the post's own category.
  }
}

export function readReturnContext() {
  try {
    // Only trust the stored context if this page load was actually referred
    // by a blog page (a listing, or another post reached via its related-
    // articles list). Without this check, a context saved much earlier in
    // the same tab session — e.g. from browsing "All" — could leak into an
    // unrelated later visit reached via a bookmark, a search engine, or a
    // link from somewhere else on the site, showing the wrong "Return to X".
    const referrer = typeof document !== 'undefined' ? document.referrer : '';
    if (!referrer) return null;
    const referrerUrl = new URL(referrer);
    if (referrerUrl.origin !== window.location.origin) return null;
    if (!/^\/blog(\/|$)/.test(referrerUrl.pathname)) return null;

    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.subsection && parsed.routedFromURL ? parsed : null;
  } catch (err) {
    return null;
  }
}
